import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsNumberService {
  constructor() {}

  esNumero(valor: string): boolean {
    return /^[0-9]*$/.test(valor);
  }
}
